import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltersModalComponent } from './filters-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialsModule } from '../../../modules/material.module';
import { TranslateModule } from '@ngx-translate/core';

export const COMPONENTS = [FiltersModalComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialsModule, TranslateModule],
  exports: COMPONENTS,
})
export class FiltersModalModule {}
